export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/5ba84b7c5997e2a9223c26a23a6fa17e.svg";